// replace image on change mats type inputs

function evamatsInitProductConfigEarly() {
  // Cache DOM elements
  const productContainer = document.querySelector('.product.config_container');
  const popupContainer = document.querySelector('.application_form__content.config_container');

  if (!productContainer && !popupContainer) return;

  // Initialize auto type
  let initialautoType, autoType;
  const productElement = document.querySelector('.product');
  
  if (productElement) {
    initialautoType = productElement.dataset.type;
    autoType = productElement.dataset.type;
  } else {
    autoType = '5os';
  }

  // Auto type normalization
  const basePath = "https://cdn.shopify.com/s/files/1/0734/7988/1010/files/";
  const typeMapping = {
    '7os': '5os', 'pickup': '5os', 'pickup2kabina': '5os', '2os': '5os',
    'van_maly': '5os', 'electro': '5os', 'custom': '5os', 'electro_7os': '5os',
    'van_duzy': 'VAN', 'camper': 'VAN', 'tractor': 'VAN', 'bus_solid': 'VAN',
    'van_duzy_solid': 'VAN', 'van_duzy_solid_2_row': 'VAN',
    'van_duzy_separate': 'bus', 'van_duzy_separate_2_row': 'bus',
    'minivan_mini': 'minivan'
  };
  autoType = typeMapping[autoType] || autoType;

  // Pattern class mapping
  const patternClassMap = {
    'romby': 'diamonds',
    'plastry miodu': 'honey',
    'krople': 'drop'
  };

  const typeCustomPrices = {
    noEdge: [450, 450, 710, 550, 910],
    withEdge: [550, 550, 910, 550, 1210]
  };

  // Для продукта с несколькими кузовами (data-type="5os, 7os"): тип для картинки берём из выбора в шаге year
  function getEffectiveBodyTypeForImage() {
    const productEl = document.querySelector('.product');
    const raw = productEl ? (productEl.dataset.type || '').trim() : '';
    if (!raw) return null;
    if (raw.indexOf(',') >= 0) {
      const yearWr = document.querySelector('[data-dropdown="year"]');
      const radio = yearWr && yearWr.querySelector('input[name="properties[Typ nadwozia]"]:checked');
      if (radio) {
        let t = (radio.getAttribute('data-body-type') || radio.value || '').trim().toLowerCase();
        if (t.indexOf('7os') >= 0) return '7os';
        if (t.indexOf('5os') >= 0) return '5os';
      }
      return raw.split(',')[0].trim();
    }
    return raw;
  }

  // Get current options from container
  function getCurrentOptions(container) {
    const matTypeElement = container.querySelector('.product-form__input[data-name="mats_type"] input:checked');
    const matType = matTypeElement ? matTypeElement.dataset.name.toLowerCase().replace(/\s+/g, '-') : '';
    let matPattern = container.querySelector('.lip__field[data-type="matPattern"] input:checked')?.dataset.value;
    const matColor = container.querySelector('.lip__field[data-type="matColor"] input:checked')?.dataset.value;
    let edgeColor = container.querySelector('.lip__field[data-type="trimColor"] input:checked')?.dataset.value;
    
    if (matPattern !== 'drop') {
      if (edgeColor === 'darkblue') edgeColor = 'blue';
      else if (edgeColor === 'blue') edgeColor = 'darkblue';
    }
    
    return { matType, matPattern, matColor, edgeColor };
  }

  // Update mat image
  function updateMatImage(container) {
    let { matType, matPattern, matColor, edgeColor } = getCurrentOptions(container);
    let typeForImage = autoType;
    if (!container.classList.contains('application_form__content')) {
      const effective = getEffectiveBodyTypeForImage();
      typeForImage = effective ? (typeMapping[effective] || effective) : autoType;
    }
    if (typeForImage === 'tir' || typeForImage === 'bus') matPattern = 'diamonds';

    let imageUrl;
    if (container.classList.contains('application_form__content')) {
      imageUrl = document.body.classList.contains('template_zamowienie-indywidualne')
        ? `${basePath}corners-${matPattern}-${matColor}-${edgeColor}.webp`
        : `${basePath}5os-${matType ? matType + '-' : ''}${matPattern}-${matColor}-${edgeColor}.webp`;
    } else {
      imageUrl = `${basePath}${typeForImage}-${matType ? matType + '-' : ''}${matPattern}-${matColor}-${edgeColor}.webp`;
    }

    const selector = window.innerWidth > 990
      ? '.product__config_image--desktop img'
      : '.product__config_image--mobile_image';

    container.querySelectorAll(selector).forEach(img => img.src = imageUrl);
  }

  // Update lip title values
  const updateLipTitleValue = () => {
    // Update radio button fields
    document.querySelectorAll('.lip__field').forEach(field => {
      const inputChecked = field.querySelector('input:checked');
      if (!inputChecked) return;

      const value = inputChecked.dataset.title;
      const titleValueElement = field.querySelector('.lip__title_value');
      if (titleValueElement) titleValueElement.textContent = value;

      // Update properties
      const selectedRodzaj = document.querySelector('input[name="Rodzaj dywaników"]:checked');
      const selectedZestaw = document.querySelector('input[name="Zestaw"]:checked');
      const selectedRozmiar = document.querySelector('input[name="Rozmiar"]:checked');

      const rodzajProperty = document.querySelector('[name="properties[Rodzaj dywaników_]"]');
      const zestawProperty = document.querySelector('[name="properties[Zestaw_]"]');
      const rozmiarProperty = document.querySelector('[name="properties[Rozmiar_]"]');
      
      if (rodzajProperty && selectedRodzaj && selectedZestaw) {
        rodzajProperty.value = selectedRodzaj.value;
        zestawProperty.value = selectedZestaw.value;
      }
      if (rozmiarProperty && selectedRozmiar) {
        rozmiarProperty.value = selectedRozmiar.value;
      }

      // Handle custom type pricing
      if (initialautoType === 'custom' && selectedRodzaj && selectedZestaw) {
        const zestawField = document.querySelector('[data-name="Zestaw"]');
        const zestawValue = zestawField?.querySelector('input:checked')?.dataset.title;
        const rodzajValue = selectedRodzaj.dataset.title;
        const zestawIndex = Array.from(selectedZestaw.closest('fieldset').querySelectorAll('input')).indexOf(selectedZestaw);
        
        let price = null;
        if (rodzajValue === '3D BEZ RANTÓW') price = typeCustomPrices.noEdge[zestawIndex];
        else if (rodzajValue === '3D Z RANTAMI') price = typeCustomPrices.withEdge[zestawIndex];
        
        const zestawTitleValue = zestawField?.querySelector('.lip__title_value');
        if (zestawTitleValue && price !== null) {
          zestawTitleValue.textContent = `${zestawValue} ${price} zł`;
        }
      }
    });

    // Update select elements
    document.querySelectorAll('select').forEach(select => {
      if (!select.value) return;
      const fieldset = select.closest('fieldset');
      const titleValueElement = fieldset?.querySelector('.lip__title_value');
      if (titleValueElement) {
        titleValueElement.textContent = select.options[select.selectedIndex].text;
      }
    });

    // Update text inputs and textareas in .lip__field (Marka samochodu, Model samochodu, Pojazd, etc.)
    document.querySelectorAll('.lip__field input[type="text"], .lip__field textarea').forEach(input => {
      const field = input.closest('.lip__field');
      const titleValueEl = field?.querySelector('.lip__title_value');
      if (titleValueEl) titleValueEl.textContent = input.value.trim();
    });
  };

  function resetMatColorForPattern(patternClass, matColorField, container) {
    if (!patternClass || !matColorField) return;

    ['honey_active', 'diamonds_active', 'drop_active'].forEach(function (cls) {
      matColorField.classList.remove(cls);
    });
    matColorField.classList.add(patternClass + '_active');

    var checkedColor = matColorField.querySelector('input[type="radio"]:checked');
    if (checkedColor) {
      var currentItem = checkedColor.closest('.lip__item');
      if (!currentItem || !currentItem.classList.contains(patternClass)) {
        checkedColor.checked = false;
      }
    }

    if (!matColorField.querySelector('input[type="radio"]:checked')) {
      var firstValid = matColorField.querySelector('.lip__item.' + patternClass + ' input[type="radio"]');
      if (firstValid) {
        firstValid.checked = true;
      }
    }

    var titleValue = matColorField.querySelector('.lip__title_value');
    var selectedColor = matColorField.querySelector('input[type="radio"]:checked');
    if (titleValue) {
      titleValue.textContent = selectedColor ? (selectedColor.dataset.title || '') : '';
    }

    if (container) {
      updateSelectedValueText(container);
    }
  }

  // Handle pattern change
  function handlePatternChange(input, parentContainer) {
    var patternClass = patternClassMap[input.value];
    if (!patternClass) return;

    var matColorField = parentContainer.querySelector('.lip__field[data-type="matColor"]');
    resetMatColorForPattern(patternClass, matColorField, parentContainer);
  }

  // EVENT DELEGATION - Single event listener instead of hundreds
  document.addEventListener('change', (e) => {
    const target = e.target;
    
    // Handle radio buttons
    if (target.type === 'radio' && 
        (target.closest('.product-form__input') || target.closest('.lip__field'))) {
      
      const parentContainer = target.closest('.config_container');
      if (!parentContainer) return;
      
      if (target.closest('.product-form__input[data-name="mats_type"]') ||
          target.closest('.product-form__input[data-name="mats_set"]') ||
          target.closest('.lip__field[data-type="matColor"]') ||
          target.closest('.lip__field[data-type="trimColor"]')) {
        updateSelectedValueText(parentContainer);
      }

      if (target.closest('.lip__field[data-type="matPattern"]')) {
        handlePatternChange(target, parentContainer);
      }

      updateMatImage(parentContainer);
      updateLipTitleValue();
    }
    
    // Handle select elements
    if (target.tagName === 'SELECT') {
      updateLipTitleValue();
    }

    // Handle text inputs and textareas in .lip__field (Marka/Model samochodu, Pojazd)
    if (target.matches('input[type="text"], textarea') && target.closest('.lip__field')) {
      updateLipTitleValue();
    }
  }, true); // Use capture phase for better performance

  // Live update .lip__title_value while typing in text fields
  document.addEventListener('input', (e) => {
    if (e.target.matches('input[type="text"], textarea') && e.target.closest('.lip__field')) {
      updateLipTitleValue();
    }
  }, true);

  // Initialize
  [productContainer, popupContainer].forEach(container => {
    if (container) {
      updateMatImage(container);
      restoreMatPattern(container);
    }
  });
  updateLipTitleValue();

  // Restore mat pattern on page load/back
  function restoreMatPattern(container) {
    if (!container) return;

    setTimeout(() => {
      const checkedPattern = container.querySelector('.lip__field[data-type="matPattern"] input:checked');
      if (!checkedPattern) return;

      const patternClass = patternClassMap[checkedPattern.value];
      if (!patternClass) return;

      const matColorField = container.querySelector('.lip__field[data-type="matColor"]');
      resetMatColorForPattern(patternClass, matColorField, container);
      updateMatImage(container);
      updateLipTitleValue();
    }, 50);
  }

  // Page show event
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    [productContainer, popupContainer].forEach(container => {
      if (container) restoreMatPattern(container);
    });
  });

  // Update selected value text for mobile
  function updateSelectedValueText(container) {
    if (window.innerWidth >= 990) return;

    const fields = [
      { selector: '.product-form__input[data-name="mats_type"]', displaySelector: '[data-name="mats_type"]', type: 'input' },
      { selector: '.product-form__input[data-name="mats_set"]', displaySelector: '[data-name="mats_set"]', type: 'input' },
      { selector: '.lip__field[data-type="matColor"]', displaySelector: '[data-type="matColor"]', type: 'color' },
      { selector: '.lip__field[data-type="trimColor"]', displaySelector: '[data-type="trimColor"]', type: 'color' }
    ];

    fields.forEach(({ selector, displaySelector, type }) => {
      const input = container.querySelector(`${selector} input:checked`);
      if (!input) return;

      const value = input.dataset.title || input.value;
      const fieldset = container.querySelector(selector);
      const titleElement = fieldset?.querySelector('.lip__title');
      const title = titleElement?.firstChild.textContent.trim() || '';
      const display = container.querySelector(`.product__config_image_selected_value${displaySelector}`);
      
      if (display) {
        let html = title ? `${title}: <span>${value}</span>` : `<span>${value}</span>`;
        if (type === 'color' && input.nextElementSibling?.src) {
          html += ` <img src="${input.nextElementSibling.src}" alt=""/>`;
        }
        display.innerHTML = html;
      }
    });
  }

  if (productContainer) updateSelectedValueText(productContainer);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', evamatsInitProductConfigEarly);
} else {
  evamatsInitProductConfigEarly();
}

// Fixed config image for mobile - LAZY INITIALIZATION
let configImageInitialized = false;

function initConfigImage() {
  if (configImageInitialized) return;
  configImageInitialized = true;

  const configImage = document.querySelector('.product__config_image--main.product__config_image--mobile');
  const matPatternsColors = document.querySelector('[data-dropdown="mats_set_type"]');
  const matPatternsColorsAdditional = document.querySelector('[data-dropdown="mat_patterns_colors"]');
  
  if (!configImage || (!matPatternsColors && !matPatternsColorsAdditional)) return;

  let isFirst = matPatternsColorsAdditional?.closest('.product__dropdown_wr') === document.querySelector('.product__dropdown_wr');

  function toggleVisibility() {
    if (window.innerWidth < 990) {
      configImage.classList.add('is-fixed');
      const isDropdownOpen = (matPatternsColors?.classList.contains('open')) ||
                            (matPatternsColorsAdditional?.classList.contains('open') && !isFirst);
      configImage.classList.toggle('fixed_hidden', !isDropdownOpen);
    } else {
      configImage.classList.remove('is-fixed', 'fixed_hidden');
    }
  }

  toggleVisibility();

  if (isFirst) {
    let counter = 0;
    window.addEventListener('scroll', () => {
      if (counter > 0) return;
      const distance = matPatternsColors?.getBoundingClientRect().top;
      if (distance <= 200) {
        isFirst = false;
        toggleVisibility();
        counter++;
      }
    }, { passive: true });
  }

  window.addEventListener('resize', toggleVisibility, { passive: true });

  // EVENT DELEGATION for buttons
  document.addEventListener('click', (e) => {
    if (e.target.closest('.product__dropdown_button')) {
      setTimeout(toggleVisibility, 500);
    }
    if (e.target.closest('.product__config_image_remove_fixed')) {
      configImage.classList.toggle('fixed_hidden');
    }
  }, true);

  // Mutation observers
  [matPatternsColors, matPatternsColorsAdditional].forEach(element => {
    if (!element) return;
    new MutationObserver(toggleVisibility).observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
}

// Initialize only when needed (on first interaction or scroll)
if (window.innerWidth < 990) {
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      initConfigImage();
      observer.disconnect();
    }
  }, { rootMargin: '100px' });
  
  const target = document.querySelector('.product__config_image--main');
  if (target) observer.observe(target);
}

// Config steps - OPTIMIZED with event delegation
(() => {
  var formContainers = document.querySelectorAll('.config_container');
  if (formContainers.length === 0) {
    formContainers = Array.from(document.querySelectorAll('.product')).filter(function (p) {
      return p.querySelector('.product__dropdown_wr');
    });
  }
  if (formContainers.length === 0) return;
  console.log('[product-config] formContainers:', formContainers.length);

  formContainers.forEach(container => {
    if (!container.querySelector('.product__dropdown_wr')) return;

    container.querySelectorAll('fieldset .error-message').forEach(el => el.style.display = 'none');

    const faqWrappers = container.querySelectorAll('.product__dropdown_wr');

    function triggerFaq(element) {
      const wrapper = element.closest('.product__dropdown_wr');
      const inner = wrapper.querySelector('.product__dropdown_inner');

      faqWrappers.forEach(w => {
        if (w === wrapper) return;
        w.classList.remove('open');
        const innerOther = w.querySelector('.product__dropdown_inner');
        innerOther.classList.remove('open');
        if (innerOther.classList.contains('super_done')) {
          innerOther.classList.add('done');
        }
      });

      const isOpen = wrapper.classList.toggle('open');
      inner.classList.toggle('open', isOpen);
      inner.classList.toggle('done', !isOpen && inner.classList.contains('super_done'));
    }

    function validateStep(wrapper, showErrors = false) {
      let stepValid = true;
      const processedRadioGroups = new Set();
      const requiredElements = wrapper.querySelectorAll('input[required], select[required], textarea[required]');
      if (showErrors) console.log('[product-config] validateStep showErrors=true, requiredElements:', requiredElements.length);

      requiredElements.forEach(element => {
        if (!showErrors && !element.offsetParent) return;
        if (showErrors && !element.offsetParent) console.log('[product-config] element no offsetParent:', element.tagName, element.name || element.id);
        let valid = true;

        if (element.type === 'radio') {
          if (processedRadioGroups.has(element.name)) return;
          processedRadioGroups.add(element.name);
          valid = [...wrapper.querySelectorAll(`input[type="radio"][name="${element.name}"]`)]
            .some(radio => radio.checked);
        } else if (element.type === 'checkbox') {
          valid = element.checked;
        } else {
          valid = element.value.trim() !== '';
        }

        const fieldset = element.closest('fieldset');
        const errorMessage = fieldset ? fieldset.querySelector('.error-message') : null;
        if (showErrors) console.log('[product-config] el', element.tagName, element.name || element.id, 'valid=', valid, 'fieldset=', !!fieldset, 'errorMessage=', !!errorMessage);
        if (errorMessage) {
          if (showErrors) {
            errorMessage.style.setProperty('display', !valid ? 'block' : 'none', 'important');
            if (showErrors) console.log('[product-config] set errorMessage.display =', !valid ? 'block' : 'none');
          } else if (valid) {
            errorMessage.style.setProperty('display', 'none', 'important');
          }
        }
        if (!valid) stepValid = false;
      });
      if (showErrors) console.log('[product-config] validateStep result stepValid=', stepValid);
      return stepValid;
    }

    function updateContinueButton(wrapper) {
      const continueBtn = wrapper.querySelector('.product__dropdown_button');
      if (!continueBtn) return;

      const isValid = validateStep(wrapper, false);
      // Не ставим disabled — иначе клик по кнопке не вызывает click, и error-message не показывается
      continueBtn.removeAttribute('disabled');
      continueBtn.classList.toggle('disabled-button', !isValid);
      continueBtn.setAttribute('aria-disabled', !isValid);
    }

    function revalidate(wrapper) {
      const inner = wrapper.querySelector('.product__dropdown_inner');
      const isValid = validateStep(wrapper, false);

      if (!isValid) {
        inner.classList.remove('super_done');
        wrapper.classList.remove('complete');
        setFollowingStepsDisabled(wrapper, true);
      }

      updateContinueButton(wrapper);
      if (container.querySelector('.application_form__next_button')) {
        updateNextButtonState(container);
      }
    }

    // Initialize buttons
    faqWrappers.forEach(wrapper => updateContinueButton(wrapper));

    // EVENT DELEGATION for all interactions
    container.addEventListener('input', (e) => {
      const wrapper = e.target.closest('.product__dropdown_wr');
      if (wrapper && e.target.matches('input[required], select[required], textarea[required]')) {
        revalidate(wrapper);
      }
    }, true);

    container.addEventListener('change', (e) => {
      const wrapper = e.target.closest('.product__dropdown_wr');
      if (wrapper && e.target.matches('input[required], select[required], textarea[required]')) {
        revalidate(wrapper);
      }
    }, true);

    container.addEventListener('click', (e) => {
      // Handle dropdown title clicks
      if (e.target.closest('.product__dropdown_title')) {
        triggerFaq(e.target.closest('.product__dropdown_title'));
        return;
      }

      // Handle continue button clicks
      const continueBtn = e.target.closest('.product__dropdown_button');
      if (continueBtn) {
        const wrapper = continueBtn.closest('.product__dropdown_wr');
        const inner = wrapper && wrapper.querySelector('.product__dropdown_inner');
        console.log('[product-config] click Dalej, wrapper=', !!wrapper, 'data-dropdown=', wrapper && wrapper.getAttribute('data-dropdown'));

        if (!wrapper || !inner) return;
        if (!validateStep(wrapper, true)) {
          updateContinueButton(wrapper);
          return;
        }

        wrapper.querySelectorAll('.error-message').forEach(el => el.style.display = 'none');
        wrapper.classList.remove('open');
        wrapper.classList.add('complete');
        inner.classList.remove('open');
        inner.classList.add('done', 'super_done');

        const nextWrapper = getNextDropdown(wrapper);
        if (nextWrapper) {
          nextWrapper.classList.add('open');
          nextWrapper.classList.remove('disabled');
          const nextInner = nextWrapper.querySelector('.product__dropdown_inner');
          nextInner.classList.add('open');
          nextInner.classList.remove('done');
          if (nextWrapper.getAttribute('data-dropdown') === 'mats_set_type') {
            filterZestawByBodyType();
          }
          // Extras — дополнительный шаг: снимаем disabled вместе с heel, но не раскрываем
          if (nextWrapper.classList.contains('product__dropdown_wr--heel')) {
            const extrasWr = nextWrapper.nextElementSibling;
            if (extrasWr && extrasWr.classList.contains('product__dropdown_wr--extras')) {
              extrasWr.classList.remove('disabled');
            }
          }

          const nextTitle = nextWrapper.querySelector('.product__dropdown_title');
          const popup = document.querySelector('#popupOverlayApplicationForm');
          const isInsidePopup = wrapper.closest('.popup');

          setTimeout(() => {
            if (nextTitle) {
              if (isInsidePopup) {
                popup.scrollTo({ top: nextTitle.offsetTop - 20, behavior: 'smooth' });
              } else {
                window.scrollTo({
                  top: nextTitle.getBoundingClientRect().top + window.scrollY - 350,
                  behavior: 'smooth'
                });
              }
            }
          }, 500);
        }

        if (container.querySelector('.application_form__next_button')) {
          updateNextButtonState(container);
        }
      }
    }, true);

    function getNextDropdown(current) {
      let next = current.nextElementSibling;
      while (next) {
        if (next.classList.contains('product__dropdown_wr') &&
            !next.classList.contains('product__dropdown_wr--extras')) {
          next.classList.remove('disabled');
          return next;
        }
        next = next.nextElementSibling;
      }
      return null;
    }

    var stepWrappers = Array.from(container.querySelectorAll('.product__dropdown_wr')).filter(function (w) {
      return !w.classList.contains('product__dropdown_wr--heel') && !w.classList.contains('product__dropdown_wr--extras');
    });
    stepWrappers.forEach(function (wrapper, i) {
      const title = wrapper.querySelector('.product__dropdown_title');
      if (title) title.innerHTML = (i + 1) + '. ' + title.innerHTML;
      if (i === 0) {
        wrapper.classList.add('open');
        var inner = wrapper.querySelector('.product__dropdown_inner');
        if (inner) inner.classList.add('open');
        wrapper.classList.remove('disabled');
      }
    });

    function updateNextButtonState(container) {
      const steps = container.querySelectorAll('.product__dropdown_wr');
      const nextButton = container.querySelector('.application_form__next_button');
      if (!steps.length || !nextButton) return;

      const allCompleted = [...steps].every(step => {
        if (step.classList.contains('product__dropdown_wr--heel') ||
            step.classList.contains('product__dropdown_wr--extras') ||
            !step.querySelector('.product__dropdown_button')) return true;
        return step.querySelector('.product__dropdown_inner')?.classList.contains('super_done');
      });

      nextButton.disabled = !allCompleted;
      nextButton.classList.toggle('disabled-button', !allCompleted);
    }

    function setFollowingStepsDisabled(currentWrapper, disabled) {
      let next = currentWrapper.nextElementSibling;
      while (next) {
        if (next.classList.contains('product__dropdown_wr') &&
            !next.classList.contains('product__dropdown_wr--heel') &&
            !next.classList.contains('product__dropdown_wr--extras')) {
          next.classList.toggle('disabled', disabled);
        }
        next = next.nextElementSibling;
      }
    }
  });

  // Фильтрация вариантов Zestaw по выбранному типу кузова (5os/7os): только display block/none
  function filterZestawByBodyType() {
    const yearWr = document.querySelector('[data-dropdown="year"]');
    const bodyTypeRadio = yearWr && yearWr.querySelector('input[name="properties[Typ nadwozia]"]:checked');
    const matsSetWr = document.querySelector('[data-dropdown="mats_set_type"]');
    const container = (matsSetWr && matsSetWr.closest('.config_container')) || document;
    const matsSet = container.querySelector('.product-form__input[data-name="mats_set"]');
    if (!matsSet) return;

    const inputs = matsSet.querySelectorAll('input[type="radio"]');
    if (!inputs.length) return;

    function norm(s) {
      return (s || '').trim().toLowerCase().replace(/\s+/g, ' ');
    }
    let selectedType = '';
    if (bodyTypeRadio) {
      selectedType = (bodyTypeRadio.getAttribute('data-body-type') || bodyTypeRadio.value || '').trim().toLowerCase();
      if (selectedType.includes('7os')) selectedType = '7os';
      else if (selectedType.includes('5os')) selectedType = '5os';
      else selectedType = '';
    }

    inputs.forEach(function (input) {
      const types = (input.getAttribute('data-body-types') || '').trim();
      const label = container.querySelector('label[for="' + input.id + '"]');
      if (!selectedType) {
        input.style.display = '';
        if (label) label.style.display = '';
        return;
      }
      const allowed = types.split(/\s+/).filter(Boolean).map(norm);
      const show = allowed.length === 0 || allowed.some(function (t) { return t === selectedType; });
      input.style.display = show ? '' : 'none';
      if (label) label.style.display = show ? '' : 'none';
    });

    const checked = matsSet.querySelector('input[type="radio"]:checked');
    if (checked && checked.style.display === 'none') {
      const firstVisible = matsSet.querySelector('input[type="radio"]:not([style*="display: none"])');
      if (firstVisible) {
        firstVisible.checked = true;
        matsSet.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Картинка по кузову: у видимых вариантов подставить data-image-5os / data-image-7os
    if (selectedType) {
      inputs.forEach(function (input) {
        if (input.style.display === 'none') return;
        const label = container.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        const img = label.querySelector('img[data-image-5os], img[data-image-7os]');
        if (!img) return;
        const src = img.getAttribute('data-image-' + selectedType);
        if (src) img.src = src;
      });
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-dropdown="year"] input[name="properties[Typ nadwozia]"]')) {
      filterZestawByBodyType();
      [productContainer, popupContainer].forEach(function (c) {
        if (c) updateMatImage(c);
      });
    }
  }, true);

  // Year select handler - EVENT DELEGATION
  document.addEventListener('change', (e) => {
    const normalize = (str) => (str || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ł/g, 'l')
      .replace(/Ł/g, 'l')
      .toLowerCase()
      .trim();

    const shouldHideHeelMount = (input) => {
      if (!input) return false;
      const selected = normalize(input.dataset.title || input.value || '');
      return (
        selected === 'tyl'
        || selected === 'bagaznik'
        || selected === 'mata do bagaznika'
        || selected === 'bagaznik maly'
        || selected === 'bagaznik duzy'
      );
    };

    const syncHeelMountGroupsVisibility = (input) => {
      const hideMount = shouldHideHeelMount(input);
      const heelMountGroups = document.querySelectorAll('.product__dropdown_wr--heel .option-group');
      if (!heelMountGroups.length) return;

      heelMountGroups.forEach((group) => {
        const groupName = normalize(group.getAttribute('data-group'));
        const isMountGroup = groupName === 'montaz' || groupName === 'montaz' || groupName === 'mount';
        if (!isMountGroup) return;

        group.style.display = hideMount ? 'none' : '';

        // If mounted surcharge was selected, switch to non-mounted when group becomes hidden.
        if (hideMount) {
          const activeBtn = group.querySelector('.product__upsell_item_variant.active');
          const hasMountedActive = activeBtn && /\+/.test(activeBtn.dataset.value || '');
          if (hasMountedActive) {
            const nonMountedBtn = Array.from(group.querySelectorAll('.product__upsell_item_variant'))
              .find((btn) => !/\+/.test(btn.dataset.value || ''));
            if (nonMountedBtn) nonMountedBtn.click();
          }
        }
      });
    };

    if (e.target.matches('[data-dropdown="year"] .select__select')) {
      const yearProperty = e.target.closest('.product__dropdown_wr').querySelector('.product__dropdown_value');
      if (yearProperty) {
        yearProperty.textContent = e.target.value;
      }
    }
    
    // Trunk label handler
    if (e.target.matches('[data-name="mats_set"] input')) {
      const labelTrunk = document.querySelector('.label_trunk');
      if (labelTrunk) {
        labelTrunk.classList.toggle('hidden', !e.target.classList.contains('input_trunk'));
      }
      syncHeelMountGroupsVisibility(e.target);
    }

    // Extras dropdown: update title value and .active на карточке
    var extrasWr = e.target.closest && e.target.closest('.product__dropdown_wr--extras');
    if (extrasWr && e.target.matches('input[name="product__extras"]')) {
      var item = e.target.closest('.product__upsell_item');
      if (item) {
        if (e.target.checked) item.classList.add('active');
        else item.classList.remove('active');
      }
      var valueEl = extrasWr.querySelector('.product__dropdown_value');
      if (valueEl) {
        var checked = extrasWr.querySelectorAll('input[name="product__extras"]:checked');
        valueEl.textContent = checked.length ? Array.from(checked).map(function (inp) { return inp.getAttribute('data-title') || inp.value; }).join(', ') : '';
      }
    }
  }, true);

  // Extras: клик по варианту — добавить .active и обновить value чекбокса (как в custom.js для heel)
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('product__upsell_item_variant')) return;
    var extrasWr = e.target.closest('.product__dropdown_wr--extras');
    if (!extrasWr) return;
    var groupContainer = e.target.closest('.option-group');
    var item = e.target.closest('.product__upsell_item');
    if (!groupContainer || !item) return;
    var checkbox = item.querySelector('input[name="product__extras"]');
    var variantsJson = item.dataset.variants;
    if (!checkbox || !variantsJson) return;
    var variants = JSON.parse(variantsJson);
    groupContainer.querySelectorAll('.product__upsell_item_variant').forEach(function (el) { el.classList.remove('active'); });
    e.target.classList.add('active');
    var groups = item.querySelectorAll('.option-group');
    var selectedOptions = {};
    groups.forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10) + 1;
      var active = group.querySelector('.product__upsell_item_variant.active');
      if (active) selectedOptions['option' + idx] = active.dataset.value;
    });
    var matching = variants.find(function (v) {
      return Object.keys(selectedOptions).every(function (k) { return v[k] === selectedOptions[k]; });
    });
    if (matching) {
      checkbox.value = matching.id;
      checkbox.dataset.price = matching.price;
    }
  }, true);

  // Initialize trunk label
  const checkedInput = document.querySelector('[data-name="mats_set"] input:checked');
  const labelTrunk = document.querySelector('.label_trunk');
  if (checkedInput && labelTrunk) {
    labelTrunk.classList.toggle('hidden', !checkedInput.classList.contains('input_trunk'));
  }
  if (checkedInput) {
    const evt = new Event('change', { bubbles: true });
    checkedInput.dispatchEvent(evt);
  }
})();